import { durationToText } from "../../../../../../../helpers/common"


const SessionCell = ({ session }) => {
    return (
        <>
            <p className="fw-bold text-primary mb-0">
                <small>{session.lesson?.section?.title}</small>
            </p>
            <p className="fw-bold mb-1">{session.lesson?.title}</p>
            <p className="text-muted mb-0">
                <small>{durationToText(session.lesson?.duration)}</small>
            </p>
        </>
    )
}

export default SessionCell